import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollControl() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/' || location.pathname.startsWith('/shoes')) {
      document.body.classList.add('no-vertical-scroll');
    } else {
      document.body.classList.remove('no-vertical-scroll');
    }
    return () => document.body.classList.remove('no-vertical-scroll');
  }, [location.pathname]);

  return null;
} 